<template>
<div class="wph-textile-print-location-picker">
  <div class="wph-px-4 lg:wph-px-8 wph-pb-6">
    <h3 class="wph-text-2xl wph-text-accent-dark wph-mb-4">Нанесение:</h3>
    <slot name="errors"></slot>
    <multiselect :options="availablePrintLocations" v-model="pickedLocations"
                 :multiple="true"
                 :hideSelected="true"
                 :searchable="false"
                 track-by="id"
                 label="name"
                 placeholder="Добавить нанесение"
                 v-bind="multiselectDefaultLabels"
                 @select="onLocationAdd"
                 @remove="onLocationRemove"
                 class="wph-mb-3"
    ></multiselect>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import MultiselectDefaultLabels from '../mixins/MultiselectDefaultLabels'

export default {
  name: "PrintLocationPicker",
  components: {
    Multiselect,
  },
  mixins: [MultiselectDefaultLabels],
  props: {
    product: Object,
    printLocations: Array,
    updateProduct: Function,
    updateProductProp: Function,
  },
  watch: {
    printLocations: {
      handler() {
        if (this.internalProductUpdate) return
        this.pickedLocations = this.printLocations.map((location) => {
          return this.appPrintLocations[location.data.id]
        })
      },
      immediate: true,
    }
  },
  data() {
    return {
      pickedLocations: [],
      /**
       * Осуществляется ли обновление элемента корзины из данного компонента
       * следует устанавливать в true перед добавлением мест нанесения из данного компонента
       * и сразу после обновления возвращать в false
       */
      internalProductUpdate: false,
    }
  },
  computed: {
    appPrintLocations() {
      return this.$store.state.textilePrint.locations
    },
    // доступные для данного вида текстиля места нанесения в виде списка объектов
    availablePrintLocations() {
      if (!this.product.type) {
        return []
      }
      return this.product.type.printLocations.map(locationName => {
        return Object.assign({}, this.appPrintLocations[locationName])
      })
    },
    appPrintTechnologies() {
      return this.$store.state.textilePrint.technologies
    },
    appPrintColors() {
      return this.$store.state.textilePrint.colors
    },
    appPrintSquares() {
      return this.$store.state.textilePrint.squares
    },
  },
  methods: {
    onLocationAdd(location) {
      const prepLocation = {}
      prepLocation.data = location
      prepLocation.technology = this.appPrintTechnologies[location.allowedTechnologies[0]]
      prepLocation.colors = prepLocation.technology.allowsColorPick ?
        this.appPrintColors.map(color => {
            const newColor = Object.assign({}, color)
            newColor.selected = false
            return newColor
          }) :
        null
      prepLocation.square = this.appPrintSquares[location.allowedSquares[prepLocation.technology.id][0]]
      prepLocation.cost = 0

      let w, h
      if (prepLocation.square.id === 'custom' || prepLocation.square.id === 'bagCustom') {
        ( { w, h } = prepLocation.square.defaults[prepLocation.data.id] || prepLocation.square.defaults.default )
      } else {
        w = 0, h = 0
      }
      prepLocation.w = w
      prepLocation.h = h

      prepLocation.files = []
      prepLocation.metallizedThread = false
      prepLocation.calculations = {
        needsSubstrate: false,
        totalSelectedColorsNumber: 0,
        totalPrintPriceMultiplier: 1,
      }

      this.internalProductUpdate = true
      this.updateProduct({ printLocations: [...this.product.printLocations, prepLocation] })
      this.internalProductUpdate = false
      this.updateProductProp('showPrintVisual', true)
    },
    onLocationRemove(locationToRemove) {
      this.internalProductUpdate = true
      this.updateProduct({
        printLocations: this.product.printLocations.filter((location) => location.data.id !== locationToRemove.id)
      })
      this.internalProductUpdate = false

      if (!this.product.printLocations.length) {
        this.updateProductProp('showPrintVisual', false)
      }
    },
  },
}
</script>

<style scoped>

</style>